import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Modal from "react-modal";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { AssessmentsTable } from "../InfoTabs/AllAssessments";
import { CheckInOverviewTable } from "../InfoTabs/CheckInOverview/CheckInOverview";
import AssessmentsOverview from "../InfoTabs/CheckInOverview/AssessmentsOverview";
import SDOHResults from "../InfoTabs/SDOHResults";
import { PatientNotesPDFComponent } from "../InfoTabs/PatientNotes/PatientNotes";
import { notesFilter } from "../../../../constants/constants";
import { useSelector } from "react-redux";
import { getFullName, getInitials, smartJoin } from "../../../../util/helpers";
import PatientLoader from "../../../common/PatientLoader";
import RiskPill from "../../../common/RiskPill";
import Pdf from "react-to-pdf";
import "jspdf-autotable";
import { GADAssessment } from "../InfoTabs/CheckInOverview/GADAssessment";
import { PHQAssessment } from "../InfoTabs/CheckInOverview/PHQAssessment";
import PatientConsentData from "../../billing/BillingReport/PatientConsentData";
import PatientCocmConsentData from "./PatientCocmConsentData";
export const ProfilePDF = (props) => {
  const [notesFilterValue, setNotesFilterValue] = useState(notesFilter[0]);
  const [localLoading, setLocalLoading] = useState(true);
  const [isCompleted, setCompleted] = useState(false);
  const [managedBy, setManagedBy] = useState("");
  const pdfTarget = useRef();
  const { user } = useSelector((state) => state.app);
  const { loading, singlePatientData } = useSelector((state) => state.patient);
  const { bhiLoading, bhiData } = useSelector((state) => state.bhi);
  const { assessmentLoading, assessmentsData } = useSelector(
    (state) => state.assessment
  );
  const [patientName, setPatientName] = useState(
    `${singlePatientData?.first_name} ${singlePatientData?.last_name}`
  );

  const getManagedBy = () => {
    try {
      const allManagers = [
        user?.id,
        ...singlePatientData?.shared_with_clinical_staff,
      ];
      let sharedManagers = staffData
        .filter((staff) => {
          if (allManagers.includes(staff.id)) {
            return staff;
          }
        })
        .map((staff) => {
          return getFullName(staff);
        });

      sharedManagers = smartJoin(sharedManagers);
      return sharedManagers;
    } catch (e) {
      return getFullName(user);
    }
  };

  useEffect(() => {
    if (user) {
      const tempManagedBy = getManagedBy();
      setManagedBy(tempManagedBy);
    }
  }, []);

  useEffect(() => {
    if (!loading && !bhiLoading && !assessmentLoading) {
      setLocalLoading(false);
    } else {
      setLocalLoading(true);
    }
  }, [loading, bhiLoading, assessmentLoading]);

  const [formattedData, setFormattedData] = useState([]);

  useEffect(() => {
    if (assessmentLoading) return;
    const tempObj = Object.entries(assessmentsData);
    const assessmentData = [];
    if (tempObj?.length > 0) {
      for (const [name, data] of tempObj) {
        if (!name.includes("ournal") && data?.length > 0) {
          data?.forEach((item) => {
            assessmentData.push({
              name: name,
              data: item,
            });
          });
        }
      }
    }
    setFormattedData(assessmentData);
  }, [assessmentLoading]);

  const generatePDF = async () => {
    const input = pdfTarget.current;
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const canvas = await html2canvas(input);
    const imgData = canvas.toDataURL("image/png");
    const imgProps = pdf.getImageProperties(imgData);
    const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;
  
    let heightLeft = imgHeight;
    let position = 0;
  
    pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
    heightLeft -= pdfHeight;
  
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;
    }
  
    pdf.save(`${moment(new Date()).format("MM-DD-YYYY--HH_mm_ss")}-${patientName}.pdf`);
    setCompleted(true);
    props?.setDownloadMode(false);
  };

  useEffect(() => {
    if (!localLoading) {
      setTimeout(() => {
        generatePDF();
        window.clearTimeout();
      }, 5000);
    }
  }, [localLoading]);

  return (
    <>
      {localLoading ? (
        <PatientLoader />
      ) : (
        <section
          ref={pdfTarget}
          className="container-fluid w-100 p-5 bg-white"
          style={{
            margin: "0px",
            padding: "0px",
          }}
        >
          <div className="d-flex justify-content-between my-3">
            <h3>Patient Report</h3>
            <span style={{ display: "flex", gap: "10px" }}>
              <strong className="muted-text">Download Date:</strong>{" "}
              {moment(new Date()).format("MM/DD/yyyy")}
            </span>
          </div>
          <div className="container-fluid p-3 row my-2">
            <div className="col-sm-12 col-md-3 col-lg-3">
              <div>
                <img
                  height="125px"
                  width="125px"
                  alt="User's DP"
                  style={{ borderRadius: "100%", padding: "0.2rem" }}
                  src={`https://placehold.co/125x125/f1f1f5/395E9D/?text=${getInitials(
                    patientName
                  )}`}
                />
                <RiskPill
                  styles={{ width: "40%" }}
                  type={singlePatientData?.flag}
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-3 col-lg-3">
              <div className="my-2">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  First name
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {singlePatientData?.first_name}
                </label>
              </div>
              <div className="my-2">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  Email
                </small>
                <label className="primary-text">
                  {singlePatientData?.email}
                </label>
              </div>
              <div className="my-2">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  BHI Status
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {singlePatientData?.bhi_enabled ? "Enabled" : "Disabled"}
                </label>
              </div>
              <div className="my-2">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  Managed By
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {managedBy}
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-md-3 col-lg-3">
              <div className="my-1">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  Last name
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {singlePatientData?.last_name}
                </label>
              </div>

              <div className="my-1">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  Date Of Birth
                </small>
                <label className="primary-text">
                  {singlePatientData?.date_of_birth
                    ? `${moment(props?.date_of_birth).format(
                        "MM - DD - YYYY"
                      )} (${moment().diff(
                        props?.date_of_birth,
                        "years"
                      )} yrs old)`
                    : "Unavailable"}
                </label>
              </div>
              <div className="my-1">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  BHI Diagnosis
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize", textAlign: "start" }}
                >
                  {bhiData?.diagnosis || "Unavailable"}
                </label>
              </div>
              <div className="my-1">
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  Chat Status
                </small>
                <label
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {props?.rose_chat ? "Enabled" : "Disabled"}
                </label>
              </div>
            </div>
          </div>
          <div className="d-flex container-fluid p-3 my-2">
            <span className="muted-text">Date Range:-</span>
            <strong>
              {moment(props?.startDate).format("MM/DD/YYYY")} -{" "}
              {moment(props?.endDate).format("MM/DD/YYYY")}
            </strong>
          </div>
          <div className="container-fluid p-3 my-2">
            <div className="d-flex mb-2">
              <label style={{ fontSize: "1.3rem" }}>Assessments</label>
            </div>
            <AssessmentsTable
              assessmentData={formattedData}
              onlyTaken={true}
              pdfMode={true}
            />
          </div>
          <div className="container-fluid p-3 my-2">
            <div className="d-flex mb-2">
              <label style={{ fontSize: "1.3rem" }}>GAD-7 Assessment Overview</label>
            </div>
            <GADAssessment size="12" showHeading={false} />
            <div className="d-flex mb-2">
              <label style={{ fontSize: "1.3rem" }}>PHQ Assessment Overview</label>
            </div>
            <PHQAssessment size="12" showHeading={false} />
            {/* <CheckInOverviewTable size="12" showHeading={false} /> */}
          </div>
          <div className="container-fluid p-3 my-2 row">
            <div className="d-flex mb-2">
              <label style={{ fontSize: "1.3rem" }}>Check in Overview</label>
            </div>
            {process.env.REACT_APP_DASHBOARD_TYPE === "youth" ? (
              <AssessmentsOverview size="12" showHeading={false} />
            ) : (
              <>
                <AssessmentsOverview size="7" showHeading={false} />
                <SDOHResults showLinkButton={false} height={"60vh"} />
              </>
            )}
          </div>

          <PatientNotesPDFComponent />
          {/* <div className="w-100 container-fluid d-flex my-2">
              <h4 className="primary-text-blue">BHI Program Documentation</h4>
            </div>
            <>
                {bhiData?.consent_information && (
                  <PatientConsentData
                    bhiData={bhiData}
                    singlePatientData={singlePatientData}
                  />
                )}
              </>
              <div className="w-100 container-fluid d-flex my-2">
              <h4 className="primary-text-blue">CoCM Program Documentation</h4>
            </div>
            <PatientCocmConsentData
                    bhiData={bhiData}
                    singlePatientData={singlePatientData}
                  /> */}
        </section>
      )}
    </>
  );
};
const ProfilePDFModal = ({
  modalIsOpen,
  setIsOpen,
  modalTitle = "PDF Preview",
}) => {
  Modal.setAppElement("#root");
  function closeModal() {
    setIsOpen(false);
  }
  function closeWindowAfterDownload() {
    setTimeout(() => {
      window.close();
      window.clearTimeout();
    }, 250);
  }
  const pdfOptions = {
    orientation: "portrait",
    unit: "in",
    format: [30, 17],
  };
  const customStyles = {
    overlay: {
      backgroundColor: "rgba(11, 17, 71, 0.5)",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      borderRadius: "16px",
      transform: "translate(-50%, -50%)",
      width: "80%",
    },
  };
  const [isCompleted, setCompleted] = useState(false);
  const pdfTarget = useRef();
  const downloadBtn = useRef();
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel=""
    >
      <div className="container-fluid">
        <button
          style={{
            position: "absolute",
            right: "15px",
            border: "0px",
            fontFamily: "DM Sans",
            backgroundColor: "transparent",
          }}
          onClick={closeModal}
        >
          <CloseIcon />
        </button>
        <CardLayout className="p-3">
          <div className="container-fluid">
            <h3 className="text-center">{modalTitle}</h3>
            <br />
            <ProfilePDF pdfTarget={pdfTarget} />
          </div>
          <div
            className="d-flex justify-content-end w-100 container-fluid"
            style={{ gap: "2%" }}
          >
            <Pdf
              targetRef={pdfTarget}
              filename={`${moment(new Date()).format("MM-DD-YYYY--HH_mm_ss")}}`}
              options={pdfOptions}
              onComplete={() => {
                setCompleted(true);
                closeWindowAfterDownload();
              }}
            >
              {({ toPdf }) => (
                <button
                  ref={downloadBtn}
                  onClick={() => {
                    if (!isCompleted) {
                      toPdf();
                    }
                  }}
                  className="primary-btn"
                >
                  Download
                </button>
              )}
            </Pdf>
            <button
              onClick={() => {
                closeModal();
              }}
              className="btn alternative-btn"
            >
              Cancel
            </button>
          </div>
        </CardLayout>
      </div>
    </Modal>
  );
};

export default ProfilePDFModal;
